module.exports = __webpack_public_path__ + "static/img/hb_59-min.3a7f56f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_59-min.png
// module id = TgnI
// module chunks = 1